module.exports = __webpack_public_path__ + "assets/knowledge.607a28ef.svg";